/** Pilotbetrieb auf prod: Testpersonen sollen wissen, dass nichts davon bleibt. */
export function PilotBanner() {
  return (
    <div className="pilot-banner" role="note">
      <strong>Testphase</strong> – alle Daten werden vor dem Start gelöscht. Bitte keine echten Daten eingeben.
    </div>
  );
}
